var $3dac09860f1690a0$exports = {};
const $3dac09860f1690a0$var$CARD = {
    R: 18,
    GAP: 16
};
let $3dac09860f1690a0$var$vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
let $3dac09860f1690a0$var$vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
function $3dac09860f1690a0$var$buildRectPath(W, H, R) {
    return [
        `M ${R} 0`,
        `L ${W - R} 0`,
        `A ${R} ${R} 0 0 1 ${W} ${R}`,
        `L ${W} ${H - R}`,
        `A ${R} ${R} 0 0 1 ${W - R} ${H}`,
        `L ${R} ${H}`,
        `A ${R} ${R} 0 0 1 0 ${H - R}`,
        `L 0 ${R}`,
        `A ${R} ${R} 0 0 1 ${R} 0 Z`
    ].join(' ');
}
function $3dac09860f1690a0$var$getCardConfig(W) {
    if (W < 640) return {
        R: 10,
        GAP: 18,
        mapWidthRatio: 1.0,
        mapHeightRatio: 0.5,
        notch: false
    };
    if (W < 900) return {
        R: 18,
        GAP: 16,
        mapWidthRatio: 0.5,
        mapHeightRatio: 0.5,
        notch: true
    };
    return {
        R: 18,
        GAP: 16,
        mapWidthRatio: 0.5,
        mapHeightRatio: 0.5,
        notch: true
    };
}
function $3dac09860f1690a0$var$buildNotchPath(W, H, MAP_W, MAP_H1, R, GAP) {
    const NOTCH_X = W - MAP_W - GAP; // left wall of the cut-out
    const NOTCH_Y = MAP_H1 + GAP; // floor of the cut-out
    return [
        `M ${R} 0`,
        `L ${NOTCH_X - R} 0`,
        `A ${R} ${R} 0 0 1 ${NOTCH_X} ${R}`,
        `L ${NOTCH_X} ${NOTCH_Y - R}`,
        `A ${R} ${R} 0 0 0 ${NOTCH_X + R} ${NOTCH_Y}`,
        `L ${W - R} ${NOTCH_Y}`,
        `A ${R} ${R} 0 0 1 ${W} ${NOTCH_Y + R}`,
        `L ${W} ${H - R}`,
        `A ${R} ${R} 0 0 1 ${W - R} ${H}`,
        `L ${R} ${H}`,
        `A ${R} ${R} 0 0 1 0 ${H - R}`,
        `L 0 ${R}`,
        `A ${R} ${R} 0 0 1 ${R} 0 Z`
    ].join(' ');
}
function $3dac09860f1690a0$var$buildPath(W, H, CARD) {
    const cfg = $3dac09860f1690a0$var$getCardConfig(W);
    const MAP_W = W * cfg.mapWidthRatio - cfg.GAP;
    const MAP_H1 = H * cfg.mapHeightRatio - cfg.GAP;
    const MAP_LEFT = W - MAP_W;
    const MAP_TOP = 0;
    if (!cfg.notch) // Mobile: simple rounded rect, no notch geometry needed
    return {
        d: $3dac09860f1690a0$var$buildRectPath(W, H, cfg.R),
        MAP_W: MAP_W,
        MAP_H: MAP_H1,
        MAP_LEFT: MAP_LEFT,
        MAP_TOP: MAP_TOP,
        cfg: cfg
    };
    const d = $3dac09860f1690a0$var$buildNotchPath(W, H, MAP_W, MAP_H1, cfg.R, cfg.GAP);
    return {
        d: d,
        MAP_W: MAP_W,
        MAP_H: MAP_H1,
        MAP_LEFT: MAP_LEFT,
        MAP_TOP: MAP_TOP,
        cfg: cfg
    };
}
const $3dac09860f1690a0$var$mapCard = document.querySelector('.au-mapCard');
const $3dac09860f1690a0$var$cardContent = document.getElementById('au-container');
const $3dac09860f1690a0$var$cardRoot = document.querySelector('.au-card-root');
const $3dac09860f1690a0$var$map = document.getElementById('au-mapCard');
const $3dac09860f1690a0$var$c_photo_parent = document.querySelectorAll('.card-photo');
const $3dac09860f1690a0$var$tm_details = document.querySelectorAll('.tm-details');
const $3dac09860f1690a0$var$p_name = document.querySelectorAll('.name');
const $3dac09860f1690a0$var$p_title = document.querySelectorAll('.title');
let $3dac09860f1690a0$var$prevIsMobile = null;
let $3dac09860f1690a0$var$lastW = 0, $3dac09860f1690a0$var$lastH = 0, $3dac09860f1690a0$var$lastCfg = null;
function $3dac09860f1690a0$var$reparentMapCard(isMobile) {
    if (isMobile === $3dac09860f1690a0$var$prevIsMobile) return;
    $3dac09860f1690a0$var$prevIsMobile = isMobile;
    if (isMobile) {
        $3dac09860f1690a0$var$mapCard.style.position = 'static';
        $3dac09860f1690a0$var$mapCard.style.background = "none";
        $3dac09860f1690a0$var$mapCard.style.boxShadow = "none";
        $3dac09860f1690a0$var$mapCard.style.width = '100%';
        console.log($3dac09860f1690a0$var$c_photo_parent, $3dac09860f1690a0$var$p_name, $3dac09860f1690a0$var$p_title);
        // for (let i = 0; i < c_photo_parent.length -1; i++) {
        //     const heading = c_photo_parent[i].querySelector('.tm-heading');
        //     if (!heading) continue;
        //     heading.appendChild(p_name[i]);
        //     heading.appendChild(p_title[i]);
        // }
        $3dac09860f1690a0$var$cardContent.style.width = '100%';
        $3dac09860f1690a0$var$cardContent.insertBefore($3dac09860f1690a0$var$mapCard, $3dac09860f1690a0$var$cardContent.children[1]);
        $3dac09860f1690a0$var$map.style.minHeight = '0';
    } else {
        $3dac09860f1690a0$var$cardRoot.appendChild($3dac09860f1690a0$var$mapCard);
        $3dac09860f1690a0$var$mapCard.style.position = 'absolute';
        $3dac09860f1690a0$var$mapCard.style.background = "linear-gradient(45deg, #ecf0f2 0%, #f7f8f9 100%)";
        $3dac09860f1690a0$var$mapCard.style.boxShadow = "8px 8px 10px rgba(0, 0, 0, 0.4), -10px -15px 20px rgba(255, 255, 255, 0.2), inset 0 -3px 4px -1px rgba(0, 0, 0, 0.4), inset 0 3px 4px -1px rgba(255,255,255,0.4), inset 0 0 5px 1px rgba(255,255,255,0.8),  inset 0 20px 30px 0 rgba(255,255,255,0.2)";
        $3dac09860f1690a0$var$map.style.minHeight = `${MAP_H}px`;
        for(let i = 0; i < $3dac09860f1690a0$var$c_photo_parent.length; i++){
            const heading = $3dac09860f1690a0$var$c_photo_parent[i].querySelector('.tm-heading');
            if (!heading) continue;
            heading.appendChild($3dac09860f1690a0$var$p_name[i]);
            heading.appendChild($3dac09860f1690a0$var$p_title[i]);
        }
        const mapTXT_OUR_STORY = document.getElementById("au-txt-ourstory");
        if (mapTXT_OUR_STORY) mapTXT_OUR_STORY.style.minHeight = `${MAP_H - 36}px`;
    }
}
function $3dac09860f1690a0$var$applyGeometry(W, H) {
    const { d: d, MAP_W: MAP_W, MAP_H: MAP_H1, MAP_LEFT: MAP_LEFT, MAP_TOP: MAP_TOP, cfg: cfg } = $3dac09860f1690a0$var$buildPath(W, H, $3dac09860f1690a0$var$CARD);
    $3dac09860f1690a0$var$lastW = W;
    $3dac09860f1690a0$var$lastH = H;
    $3dac09860f1690a0$var$lastCfg = cfg;
    // L-card clip
    const auCard = document.getElementById('au-l-card');
    if (auCard) auCard.style.clipPath = `path("${d}")`;
    // Single SVG path — convex-bubble filter only
    const shadowPath = document.getElementById('au-insetLightPath');
    if (shadowPath) shadowPath.setAttribute('d', d);
    // SVG canvas sizing
    const svg = document.getElementById('au-insetSvg');
    if (svg) {
        svg.setAttribute('width', W);
        svg.setAttribute('height', H);
    }
    // Map card position + size — MAP_H is only a floor; content may grow it further
    const map = document.getElementById('au-mapCard');
    if (map) {
        map.style.left = `${MAP_LEFT}px`;
        map.style.top = `${MAP_TOP}px`;
        map.style.width = `${MAP_W}px`;
    // map.style.minHeight = `${MAP_H}px`;
    }
}
// Keeps the notch cut-out in sync with au-mapCard's real (content-driven)
// height, independent of whether cardRoot itself resized.
function $3dac09860f1690a0$var$applyNotchFromMapHeight(mapH) {
    if (!$3dac09860f1690a0$var$lastCfg || !$3dac09860f1690a0$var$lastCfg.notch) return; // mobile: plain rect, no notch to sync
    const MAP_W = $3dac09860f1690a0$var$lastW * $3dac09860f1690a0$var$lastCfg.mapWidthRatio - $3dac09860f1690a0$var$lastCfg.GAP;
    const d = $3dac09860f1690a0$var$buildNotchPath($3dac09860f1690a0$var$lastW, $3dac09860f1690a0$var$lastH, MAP_W, mapH, $3dac09860f1690a0$var$lastCfg.R, $3dac09860f1690a0$var$lastCfg.GAP);
    const auCard = document.getElementById('au-l-card');
    if (auCard) auCard.style.clipPath = `path("${d}")`;
    const shadowPath = document.getElementById('au-insetLightPath');
    if (shadowPath) shadowPath.setAttribute('d', d);
}
const $3dac09860f1690a0$var$ro = new ResizeObserver((entries)=>{
    const { width: width, height: height } = entries[0].contentRect;
    const isMobile = width < 640; // stays in sync with getCardConfig's own threshold
    $3dac09860f1690a0$var$reparentMapCard(isMobile);
    $3dac09860f1690a0$var$applyGeometry(width, height); // always runs now
});
$3dac09860f1690a0$var$ro.observe($3dac09860f1690a0$var$cardRoot);
// Separate observer: reacts only to au-mapCard's own box (content growth,
// font swaps, etc.) — offsetHeight avoids contentRect's content-box-only
// measurement, which would exclude au-mapCard's padding.
const $3dac09860f1690a0$var$mapRo = new ResizeObserver(()=>{
    if ($3dac09860f1690a0$var$mapCard) $3dac09860f1690a0$var$applyNotchFromMapHeight($3dac09860f1690a0$var$mapCard.offsetHeight);
});
if ($3dac09860f1690a0$var$mapCard) $3dac09860f1690a0$var$mapRo.observe($3dac09860f1690a0$var$mapCard);


//# sourceMappingURL=web-build.6b7a29e4.js.map
